import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/database";
import "firebase/compat/storage";
import "firebase/compat/app-check"; //

class Firebase {
	constructor(props) {
		// let config = props.config;

		const { appCheckRecaptchaKey, ...firebaseConfig } = props.config;

		// window.FIREBASE_APPCHECK_DEBUG_TOKEN = true;

		//let data = require(`./${login}.json`);
		firebase.initializeApp(firebaseConfig);

		if (appCheckRecaptchaKey) {
			const appCheck = firebase.appCheck();

			appCheck.activate(
				new firebase.appCheck.ReCaptchaEnterpriseProvider(appCheckRecaptchaKey),
				true // enableAutoRefresh
			);
		}

		this.auth = firebase.auth();
		this.bd = firebase.database();
		this.storage = firebase.storage();
		this.deleteSessions = () => {
			firebase.app().delete();
		};

		//
		//
		// const app = initializeApp(config);
		// this.auth = app.auth();
		// this.bd = app.database();
		// this.storage = app.storage();
		// this.deleteSessions = () => {
		// 	app.app().delete();
		// };
	}

	doSignInWithEmailAndPassword = (email, password) =>
		this.auth.signInWithEmailAndPassword(email, password);

	doSignOut = () => {
		this.auth.signOut();
		this.deleteSessions();
	};
}

export default Firebase;
